
var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function() {
  var chatDict = {
   

actionPostbackError: "A aparut o eroare in timpul procesarii actiunii.Te rugam incearca din nou.",
addToCartButtonLabel: "Adauga in cos",
addedButtonLabel: "Adaugat",
addingToCartButtonLabel: "Adaugare in cos",
agent: "Agent",
automated: "Automat",
backLabelBackAt: "Revenim la {time}",
backLabelBackInAMinute: "Revenim in 1 minut",
backLabelBackInAnHour: "Revenim in 1 ora",
backLabelBackInDays: "Revenim in {value} zile",
backLabelBackInHours: "Revenim in {value} ore",
backLabelBackInMinutes: "Revenim in {value} minute",
backLabelBackOn: "Back on {weekday}",
backLabelBackTomorrow: "Revenim curand",
bot: "Bot",
campaignClickToReply: "Click pentru raspuns",
cannotUploadMoreFiles: "Nu puteti incarca mai mult de {maxFilesPerUpload} fisiere odata.",
characters: "caractere",
chatTitle: "DispoTrading",
chatWithUs: "Chat with us",
clickToRetry: "Apasa pentru a reincerca.",
close: "Inchide",
contactFormAskAdditionalMessage: "Mai adaugati si alte informatii?",
contactFormAskEmail: "Cum te putem contacta?",
contactFormAskMessage: "Da-ne orice alte detalii care ne-ar ajuta",
contactFormAskSubject: "Cu ce te putem ajuta?",
contactFormAskSubjectOther: "Completeaza subiectul:",
contactFormEndingMessage: "Multumim, iti raspundem pe email.",
contactFormEndingMessageWithHelpCenter: "Multumim, iti raspundem pe email. intre timp vizitati Centrull de Suport!",
contactFormIntro: "Lasati-ne un mesaj si va raspundem pe email.",
contactFormIntroWithEmail: "Multumim ca ne-ati contactat! Lasati-ne un email si va raspundem cat de curand putem.",
contactFormSSPUnsuccessfulAskAdditionalMessage: "Multumim ca ne-ati contactat. Lasati-ne un mesaj si va raspundem pe email.",
conversationTimestampHeaderFormat: "D MMMM",
emailCaptureInputLabel: "Lasati-ne un email",
emailCaptureOfflineThanksText: "Multumim {email}! Iti raspundem cat de curand putem.",
emailCaptureOfflineTriggerText: "Suntem in afara programului, lasati-ne un email si va raspundem cat mai curand.",
emailCaptureOnlineThanksText: "Multumim! Va trimitem email la {email} daca parasiti chatul.",
emailCaptureOnlineTriggerText: "Lasati-ne un email si va raspundem cat mai curand.",
emailCapturePlaceholder: "exemplu@email.com",
emailCaptureRequiredEmailPlaceholder: "Lasati-ne emailul Dv.",
emailCaptureRequiredMessagePlaceholder: "Scrieti mesajul",
emailCaptureThanksText: "Multumim ca ne-ati contactat! Veti primi raspuns aici sau pe email daca lasati unul.",
emailCaptureTriggerBackOnlineAt: "Revenim la {time}",
emailCaptureTriggerBackOnlineOn: "We will be back online on {weekday}",
emailCaptureTriggerTextBase: "Lasati-ne un email si va vom raspunde.",
emailCaptureTriggerTypicalReplyHours: "Multumim ca ne-ati contactat! Revenim in cateva ore.",
emailCaptureTriggerTypicalReplyMinutes: "Multumim ca ne-ati contactat! Revenim in cateva minute.",
fetchHistory: "Incarca mai mult",
fetchingHistory: "Descarca istoricul ...",
fileTooBig: "Fisierul trebuie sa fie mai mic de {maxFileSize} MB",
genericErrorButtonLabel: "Ceva nu a functionat",
getRepliesByEmail: "Obtine raspunsuri pe email",
headerText: "Gorgias Team",
howCanWeHelpToday: "Cu ce te putem ajuta azi?",
inputPlaceholder: "Scrie un mesaj...",
introductionText: "Cu ce te putem ajuta?",
invalidFileError: "Doar imaginile sunt acceptate. Alegeti un fisier cu una din extensiile (jpg, jpeg, png, gif, or bmp).",
leaveAMessage: "Lasa un mesaj",
leaveAnotherMessage: "Lasa un al mesaj",
messageDelivered: "Trimis",
messageError: "A aparut o reoare in trimiterea mesajului. va rugam reincercati",
messageIndicatorTitlePlural: "({count}) Mesaje noi",
messageIndicatorTitleSingular: "({count}) Mesaje noi",
messageNotDelivered: "Mesaj netrimis.",
messageRelativeTimeDay: "{value}z in urma",
messageRelativeTimeHour: "{value}h in urma",
messageRelativeTimeJustNow: "Chiar acum",
messageRelativeTimeMinute: "{value}m in urma",
messageSending: "Trimitere...",
messageTimestampFormat: "h:mm A",
noAttachmentToSend: "Nici un atasament de trimis",
offlineIntroductionText: "In afara programului",
outOfStockButtonLabel: "Deja fara stoc",
poweredBy: "Powered by",
poweredByGorgias: "Powered by Gorgias",
privacyPolicyDisclaimer: "Utilizand acest chat, sunteti de acord cu politica de confidentialitate.",
productInformation: "Informatii produs",
productQuestionShort: "Intrebare produs",
requireEmailCaptureIntro: "Pentru a contacta echipa noastra , va rugam introduceti emailul Dv.",
seePreviousMessage: "Vezi mesajul anterior",
selectOptionsLabel: "Selecteaza optiune",
send: "Trimite",
shopClosed: " ",
shopClosingInAMinute: " ",
shopClosingInLessThanAMinute: " ",
shopClosingSoon: " ",
showDetailsButtonLabel: "Arata detalii",
subject: "Subiect",
tapToRetry: "Mesaj nelivrat. Apasa pentru a reincerca.",
thanksForReachingOut: "Multumim ca ne-ati contactat!",
thatsAll: "Asta e tot",
totalPriceLabel: "Total",
unsupportedActionType: "Tip de actiune nesuportat.",
usualReplyTimeDay: "De obecei raspunde intr-o zi",
usualReplyTimeHours: "De obicei raspunde in cateva ore",
usualReplyTimeMinutes: "De obicei raspunde in cateva minute",
waitForAnAgent: "Asteptati sa va preia un agent",
waitTimeAgentsAreBusy: "Multumim ca ne-ati contactat! Timpul de asteptare este de peste 15 minute.",
waitTimeAgentsAreBusySorryToHearThat: "Va conectam cu echipa. Timpul de asteptare este de peste 15 minute.",
waitTimeLongEmailCaptured: "Multumim pentru rabdare. Va preluam imediat ce un agent e disponibil.",
waitTimeLongHeader: "Timpul de asteptare e ste mai mare ca de obicei",
waitTimeMediumEmailCaptured: "Multumim ca ne-ati contactat! Va raspundem in {waitTime} minute.",
waitTimeMediumHeader: "Va raspundem in cateva momente",
waitTimeMediumSorryToHearThat: "Va punem in contact cu echipa noastra. Va raspudem in {waitTime} minute.",
waitTimeShortEmailCaptured: "Multumim ca ne-ati contactat! Va raspundem curand.",
waitTimeShortHeader: "We will be right there!",
waitTimeShortSorryToHearThat: "Va punem in contact cu echipa noastra. Va raspudem curand.",

    
  }

var sspDict = {

    
applyPromoCode: "Aplica cod promotional",
april: "Apr",
articleRecommendationInputPlaceholder: "Pune o intrebare!",
articleThatMayHelp: "Iata un articol care v-ar putea ajuta:",
attachUpToFiles: "Atasati pana la {number} fisiere",
attemptedDelivery: "Livrare incercata",
august: "Aug",
backToHome: "Inapoi",
billingInformation: "Informatii facturare",
cancel: "Anuleaza",
cancelFulfillment: "Anuleaza pregatirea",
cancelMessageDescription: "As vrea sa anulez urmatoarea livrare",
cancelOrder: "Anuleaza o comanda",
cancelOrderShort: "Anuleaza comanda",
canceled: "Anulat",
cancelled: "Anulat",
cantSignIn: "Nu va puteti conecta?",
changeShippingAddress: "As vrea sa schimb adresa de livrare",
checkSpamFolder: "Daca nu gasiti mesajul cu codul de verificare, verificati si folderele SPAM si JUNK.",
checkpointAttemptFail: "Incercare esuata",
checkpointAvailableForPickup: "Disponibil pentru ridicare",
checkpointDelayed: "Intarziat",
checkpointDelivered: "Livrat",
checkpointException: "Exceptie",
checkpointException_001: "Exceptie",
checkpointException_002: "Client mutat",
checkpointException_003: "Refuz primire",
checkpointException_004: "Intarziat (Fromalitati vamale)",
checkpointException_005: "Intarziat (Factori externi)",
checkpointException_006: "In asteptare pentru plata",
checkpointException_007: "Adresa incorecta",
checkpointException_008: "Neridicat",
checkpointException_009: "Refuzat de curier",
checkpointException_010: "Returnare la expeditor",
checkpointException_011: "Returnat la e",
checkpointException_012: "Colet deteriorat",
checkpointException_013: "Colet pierdut",
checkpointExpired: "Expirat",
checkpointInTransit: "In tranzit",
checkpointInfoReceived: "Info primit",
checkpointOrderPlaced: "Comanda plasata",
checkpointOutForDelivery: "In livrare",
checkpointPending: "In asteptare",
checkpointPickedUp: "Ridicat",
codeExpiresIn: "Codul expira in",
codeSentTo: "Codul trimis la",
codeWillExpire: "Acest cod expira in 10 minute. Daca nu ai initiat aceasta soliciatre, te ruugam anunta-ne.",
completeReturnDeepLink: "Finalizeaza returul in pagina nostra de retur",
confirmOrder: "Confirma comanda",
confirmed: "Confirmat",
continue: "Continua",
createdAt: "Creat la",
customerHasNoOrdersEmail: "Nu s-au gasit comenzi pentru acest email",
customerHasNoOrdersPhone: "Nu s-au gasit comenzi pentru acest telefon",
damagedInDelivery: "Comanda mea a fost deteriorata in livrare",
december: "Dec",
delivered: "Livrat",
deliveredAt: "la",
deliveredOn: "Livrat pe",
deliveredVia: "Expediat via",
editOrder: "Modifica comanda",
email: "Email",
errorFetchingOrders: "A aparut o eroare la cautarea comenzilor",
errorGeneratingReturnPortalLink: "A aparut o eroare la generarea linkului paginii de retur",
errorSendingReportIssue: "Ceva n-a mers la trimiterea raportului cu problema.",
estimatedDelivery: "Livrare estimata",
etaProvidedBy: "ETA furnizat de",
expectToBeDeliveredBy: "de",
failedDelivery: "Livrare esuata",
failedFulfillment: "Pregatire esuata",
failure: "Failure",
february: "Feb",
fillYourEmailToTalkToAnAgent: "Lasati-ne un email",
findOrder: "Cauta-ti comanda",
fulfillment: "Pregatire",
fulfillmentDetails: "Detaliile pregatirii",
goBack: "Inapoi",
goToReturnPortal: "Ctre pagina de retur",
happyToHelp: "O zi placuta!",
hi: "Buna ziua,",
hiFirstname: "Buna ziua {{firstName}},",
howCanIHelp: "Cu ce te ajutam?",
iHaveTheFollowingIssue: "Am urmatoarele probleme:",
iWouldLikeToCancelTheFollowingOrder: "As vrea sa anulez comanda urmatoare",
iWouldLikeToReturnTheFollowingItems: "As vrea sa returnez produsele urmatoare",
inTransit: "In tranzit",
inTransitVia: "In tranzit prin",
incorrectOrder: "Nu am primit comanda corecta",
invalidCode: "Cod invalid",
invalidPhoneNumber: "Numar de telefon invalid",
isThisTheCorrectOrder: "Aceasta este comanda?",
itemNames: "Numele produselor",
itemsRequestedForReturn: "produse solicitate pentru retur",
january: "Ian",
july: "Iul",
june: "Iun",
labelPrinted: "Eticheta tiparita",
labelPurchased: "Eticheta achizitionata",
lastUpdated: "Ultima actualizare",
learnMore: "Afla mai multe",
lostOrderDetails: "Ati pierdut detaliile comenzii? Discutati cu un agent",
manageMyOrders: "ADMINISTRARE COMENZI - Anulare, Modificare, Returnare, Notifica probleme",
manageYourOrders: "Administreaza comenzile",
march: "Mar",
maxVerificationAttemptsReached: "S-a atins numaru maxim de incercari",
may: "Mai",
needHelp: "Nu ai rezolvat?",
noCustomerAssociatedEmail: "Nici un client asociat cu acest email",
noCustomerAssociatedPhone: "Nici un client asociat cu acest numar de telefon",
noINeedMoreHelp: "Nu inca",
november: "Noi",
october: "Oct",
of: "din",
oneItemSelected: "1 produs selectat",
or: "ori",
order: "Comanda",
orderCreated: "Comanda creata",
orderNumber: "Numar comanda",
orderPlaced: "Comanda plasata",
other: "Altele",
outForDelivery: "In livrare",
outForDeliveryVia: "In livrare prin",
partiallyRefunded: "Suma partial returnata",
pastDeliveryDate: "S-a depasit termenul extimat de asteptate",
payment: "Plata",
pendingDelivery: "In asteptarea livrarii",
pleaseRefreshPageToUseChat: "Va rugam reincarcati pagina pentru a continua utilizarea chat-ului.",
pleaseUseVerificationCodeToLogIn: "Va rugam folositi codul de verificare pentru conectare:",
previousConversation: "Mergi la conversatia anterioara",
processing: "In procesare",
processingFulfillment: "In pregatire",
provideEmailAndOrderNumber: "Trebuie sa ne furnizati un email si un numar de comanda",
quantityToReturn: "Cantitatea de returnat",
quickAnswers: "Raspunsuri rapide",
quickResponses: "Raspunsuri rapide",
readyForPickup: "Gata de ridicare",
reasonCancelOrder: "As vrea sa anulez comanda",
reasonCancelOrderDefaultResponse: "Comenzile deja plasate nu mai pot fi modificate.",
reasonCancelSubscription: "As vrea sa anulez abonamentul",
reasonCancelSubscriptionDefaultResponse: "Multumim ca ne-ati contactat legat de abonament. Va vom raspunde curans legat de pasii urmatori.",
reasonChangeDeliveryDate: "As vrea sa schimb data de livrare",
reasonChangeDeliveryDateDefaultResponse: "Comenzile deja plasate nu mai pot fi modificate.",
reasonChangeShippingAddress: "As vrea sa schimb adresa de livrare",
reasonChangeShippingAddressDefaultResponse: "Comenzile deja plasate nu mai pot fi modificate.",
reasonDidNotReceiveRefund: "Nu am primit banii pe retur",
reasonDidNotReceiveRefundDefaultResponse: "Daca plata s-a facut cu card, suma se va intoarce pe cardul folosit la plasarea comanzii.Daca s-a platit ramburs sau prin transfer bancar, plata se face in contul indicat de Dv. Poate dura cateva zile pana se proceseaza plata.\r\\n\r\\nDaca a trecut mult timp si ati primit banii, anuntati-ne sa verificam.",
reasonDiscountNotWorking: "Codul meu de discount nu merge",
reasonDiscountNotWorkingDefaultResponse: "Multumim ca ne-ati contactat. Un agent o sa va raspunda curand sa va ajute cu codul.",
reasonEditOrder: "As vrea sa modific comanda",
reasonEditOrderDefaultResponse: "Comenzile deja plasate nu mai pot fi modificate.",
reasonEditSubscription: "As vrea sa modific abonamentul",
reasonEditSubscriptionDefaultResponse: "Multumim ca ne-ati contactat legat de abonament. Va vom raspunde curans legat de pasii urmatori.",
reasonExchangeRequest: "As vrea sa schimb produse din comanda",
reasonForgotToUseDiscount: "Am uitat sa aplic codul de discount",
reasonForgotToUseDiscountDefaultResponse: "Va rog sa ne furnizati codul de discount , sa verificam.",
reasonIncorrectItems: "Am primit alte produse decat am comandat",
reasonIncorrectItemsDefaultResponse: "Ne pare rau de greseala. Va rog sa ne spuneti exact ce produse/culoare/marime ati primit.",
reasonItemsMissing: "Am articole lipsa in comanda",
reasonItemsMissingDefaultResponse: "Ne pare rau de greseala. Va rog sa ne spuneti exact ce produse nu ati primit.",
reasonNotHappy: "Nu sunt multumit de produse 👎",
reasonNotHappyDefaultResponse: "Ne pare rau. Ne gandim ce am putea imbunatati.",
reasonOrderDamaged: "Comanda mea a fost deteriorata la livrare",
reasonOrderDamagedDefaultResponse: "Ne pare rau. Va rugam sa ne trimiteti detalii si poze ale produselor afectate si sa ne spuneti daca si coletul a fost deteriorat.",
reasonOrderDefective: "Produsele din comanda sunt deteriorate",
reasonOrderDefectiveDefaultResponse: "Ne pare rau. Va rugam sa ne trimiteti detalii referitorare la defect.",
reasonOrderStillNotShipped: "Comanda mea trebuia livrata pana acum",
reasonOrderStillNotShippedDefaultResponse: "Verificam de ce nu a fost expediata comanda",
reasonOrderStuckInTransit: "Comanda me e blocata in tranzit",
reasonOrderStuckInTransitDefaultResponse: "Ne pare rau. Verificati linkul de urmarire trimis de noi sau mesajele curierului sa vedeti ce firma o livreaza. Luati legatura cu ei. La randul nostru o sa verificam si noi.",
reasonOther: "Altele",
reasonOtherDefaultResponse: "Cum va putem ajuta?",
reasonPastExpectedDeliveryDate: "Livrarea dureaza prea mult. Unde e comanda?",
reasonPastExpectedDeliveryDateDefaultResponse: "Ne pare rau. Verificati linkul de urmarire trimis de noi sau mesajele curierului sa vedeti ce firma o livreaza. Luati legatura cu ei. La randul nostru o sa verificam si noi.",
reasonReorderItems: "As vrea sa comand din nou anumite produse",
reasonReorderItemsDefaultResponse: "Sigur! Ce ati dori sa comandati din nou?",
reasonReplaceItemsRequest: "As vrea sa schimb produse in comanda",
reasonRequestDiscount: "As vrea un cod de discount",
reasonRequestDiscountDefaultResponse: "Verificam daca va incadrati al vreun discount.",
reasonRequestRefund: "As vrea sa mi se returneze banii pentru comanda returnata",
reasonRequestRefundDefaultResponse: "Verificam daca a ajuns al noi comanda returnata. Daca da, banii vor fi returnati in scurt timp. Uneori procesarea platii dureaza cateva zile.",
reasonReturnProduct: "As vrea sa returnez un produs",
reasonVeryHappy: "Sunt foarte multumit de produs 👍",
reasonVeryHappyDefaultResponse: "Va multumim pentru feedback-ul pozitiv! Ce va placut cel mai mult la produse?",
reasonWhereIsMyOrder: "Unde este comanda mea?",
refunded: "Suma returnata",
reportAnIssueWithOrder: "Notifica o problema",
reportIssue: "Notifica problema",
reportIssueShort: "Notifica o problema",
requestCancellation: "Cerere Anulare",
requestReturn: "Cerere Retur",
resendCode: "Retrimite cod",
retry: "Reincearca",
return: "Retur",
returnItems: "Retur produse",
returnOrder: "Returnare o comanda",
returnOrderShort: "Returnare Comanda",
see1MoreItem: "inca 1 produs",
see1MoreOrder: "vezi inca 1 comanda",
seeItems: "Vezi produse",
seeMoreItems: "inca {moreItemsCount}articole",
seeMoreOrders: "vezi inca {nextPageOrderCount}comenzi",
seeOrders: "Vezi comenzile",
selectAll: "Selecteaza tot",
sendCode: "Trimite cod",
sendUsAMessage: "Trimiteti-ne un mesaj",
sent: "Trimis",
september: "Sept",
severalItemsSelected: "{itemsSelectedCount} produse selectate",
shipment: "Expediere",
shipmentBeingDelivered: "Expeditia este in curs de livrare catre destinatie.",
shipping: "Transport",
shippingAddress: "Adresa livrare",
shippingInformation: "Informatii livrare",
showLessItems: "Arata mai putin",
signIn: "Conectare la cont",
signInDifferentAccount: "Conectare la un alt cont",
signInToAccessOrders: "Pentru continuare, va rugam conectativa la cont pentru a accesa comenzile.",
signInWithOrderNumber: "Conectati-va cu numar de comanda",
signedWith: "Sunteti conectat cu",
sincerely: "Cu stima,",
sms: "SMS",
sorryToHearThatEmailNotRequired: "Va punem in contact cu echipa noastra. Va raspundem curand.",
sorryToHearThatEmailRequired: "Va rugam sa introduceti email-ul, sa va punem in contact cu echipa noastra.",
sorryToHearThatHandoverToLiveChatFewHours: "Va punem in contact cu echipa noastra. Va raspundem in cateva ore.",
sorryToHearThatHandoverToLiveChatFewMinutes: "Va punem in contact cu echipa noastra. Va raspundem in cateva minute.",
startConversation: "Incepeti conversatia",
stuckInTransit: "Comanda mea este blocata in tranzit de cateva zile",
subtotal: "Subtotal (Inc. taxe)",
summary: "Sumar",
supportTeam: "Echipa {{shopFriendlyName}}",
talkToLiveAgent: "discuta cu cineva",
thanksOurTeamWillRespond: "Multumim, echipa noastra va raspunde curand.",
total: "Total",
track: "Urmareste",
trackAndManageMyOrders: "ADMINISTRARE COMENZI - Urmarire, Anulare, Modificare, Returnare, Notifica probleme",
trackOrder: "Urmareste comanda",
trackOrderSentVia: "Trimis prin {trackingCompany}",
trackOrderShort: "Urmareste comanda",
tracking: "Link Urmarire",
trackingNumber: "AWB",
trackingNumberPrefix: "Numar AWB",
trackingUrl: "Link urmarire",
trySigningInWithOrderNumber: "Incearca conectarea cu numar de comanda",
unavailable: "Indisponibil",
unfulfilled: "Neprocesat",
verificationCodeField: "cod din 6 cifre",
wasThisHelpful: "V-a fost de ajutor?",
wasThisRelevant: "A fost util?",
whatIsWrongWithOrder: "Ce probleme sunt cu comanda?",
yesCloseMyRequest: "Da, inchide solicitarea",
yesThankYou: "Da, multumesc",
youWillGetRepliesByEmail: "Multumim! Veti primi raspuns pe email.",
youWillGetRepliesHereAndByEmail: "Multumim! Veti primi raspuns aici si pe email.",
yourEmail: "Email-ul tau",
yourOrders: "Comenzile tale",
yourPhoneNumber: "Telefonul tau"


	}
 
    window.GORGIAS_CHAT_TEXTS = chatDict
    GorgiasChat.updateTexts(chatDict)
    GorgiasChat.updateSSPTexts(sspDict)
   
})